export const APPLE_STORE = "https://apps.apple.com/sg/app/pints-app/id1635294324"
export const GOOGLE_PLAY_STORE = "https://play.google.com/store/apps/details?id=app.pints&hl=en&gl=SG"